(ns practitest.frontend.components2.dashboard.transforms.stacked-bar
  (:require [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.components2.dashboard.helpers :as h]))

(def StackedBarItem
  [:map
   [:category :string]
   [:group :string]
   [:value number?]])

(def StackedBarSeriesData
  [:map
   [:chart/data [:vector StackedBarItem]]
   [:chart/inactive-groups [:vector [:string]]]
   [:chart/categories [:vector [:string]]]
   [:chart/series [:vector [:string]]]])

(defn transform
  {:malli/schema [:=> [:cat [:map
                             [:chart/data sc/SeriesCategories]
                             [:chart/cell-width {:optional true} [:maybe [:enum :regular :double]]]]]
                  StackedBarSeriesData]}
  [{{:keys [series categories]} :chart/data
    :chart/keys                 [toggle-legend cell-width  x-values-map]
    :or                         {toggle-legend {}}
    :as                         chart}]
  (let [active?              #(toggle-legend % true)
        a-series             (h/active-series series active?)
        categories-count     (count categories)
        inactive-groups      (->> series
                                  (remove #(some #{(:name %)} (map :name a-series)))
                                  (mapv :name))]

    (merge chart
           {:chart/data
            (vec
             (mapcat (fn [idx category]
                       (map (fn [{group :name data :data}]
                              {:category category
                               :group    group
                               :value    (nth data idx 0)})
                            a-series))
                     (range categories-count)
                     categories))

            :chart/inactive-groups inactive-groups
            :chart/categories      categories
            :chart/series          (mapv :name series)})))